import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

type LogInButtonProps = {
  className: string;
  label?: any;
  style?: any;
  register?: boolean;
};

const LogInButton: React.FC<LogInButtonProps> = ({
  className = "",
  label,
  style = {},
  register,
}) => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    const preferredLogin = localStorage.getItem("chosen_login");

    loginWithRedirect({
      connection:
        preferredLogin === "google"
          ? "google-oauth2"
          : preferredLogin === "username-password"
          ? "Username-Password-Authentication"
          : undefined,
    });
  };

  return (
    <div
      onClick={() => {
        if (register) loginWithRedirect({ screen_hint: "signup" });
        else handleLogin();
      }}
      style={style}
      className={className}
    >
      {label}
    </div>
  );
};

export default LogInButton;
